module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-ja.decf4aff11bd48f0c577.svg";